import TvHelpScreenLayout from 'components/Help/TvHelpScreenLayout.ctv';
import TvQrContentLayout from 'components/Help/TvQRContentLayout.ctv';

const TvContactUsScreen: React.FC = () => {
  return (
    <TvHelpScreenLayout>
      <TvQrContentLayout
        title="Fale conosco"
        url="bandplay.com/contato"
        qrCodeValue="https://bandplay.com/contato"
      />
    </TvHelpScreenLayout>
  );
};

export default TvContactUsScreen;
